import React, { Component } from "react";
import { app } from "../stitch";

import { Link } from "react-router-dom";
import { ModalContext } from "../App.js";

export default class EmailConfirmer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isConfirmed: false,
      toSendAnother: false,
      email: "",
      resendError: "",
      resendSuccess: false,
    };
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleResend = () => {
    app.emailPasswordAuth
      .resendConfirmationEmail(this.state.email)
      .then((result) => {
        this.setState({ resendSuccess: true });
      })
      .catch((err) => {
        if ((err.message = "user not found")) {
          this.setState({
            resendError: "It appears that you never registered with this email",
          });
        } else this.setState({ resendError: err.message });
      });
  };

  componentDidMount() {
    const url = window.location.search;
    const params = new URLSearchParams(url);
    const token = params.get("token");
    const tokenId = params.get("tokenId");

    app.emailPasswordAuth
      .confirmUser(token, tokenId)
      .then((result) => {
        this.setState({ loading: false, isConfirmed: true });
        console.log("looks like shit worked");
      })
      .catch((err) => {
        this.setState({ loading: false, isConfirmed: false });
        console.log("there was an err", err);
      });
  }

  render() {
    if (this.state.loading) return <div>confirming...</div>;

    return (
      <div>
        {this.state.isConfirmed ? (
          <div>
            Confirmed! For security reasons, you have to re-enter your
            credentials again to sign in
            <ModalContext.Consumer>
              {({ isModalShowing, toggleModal }) => (
                <Link
                  to="/"
                  onClick={() => {
                    toggleModal();
                  }}
                >
                  Go To Login Screen
                </Link>
              )}
            </ModalContext.Consumer>
          </div>
        ) : (
          <React.Fragment>
            <div>Confirmation error, try one of the following:</div>
            <div
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ toSendAnother: true });
              }}
            >
              1) Send another email (FYI, links attached to emails expire after
              2 hours)
            </div>
            <div>
              2) Open up this link from your email again (don't refresh, your
              unique token won't query doing so)
            </div>
            <div>
              3) If you have already verified, token automatically expires
            </div>
            <ModalContext.Consumer>
              {({ isModalShowing, toggleModal }) => (
                <Link
                  to="/"
                  onClick={() => {
                    toggleModal();
                  }}
                >
                  Go To Login Screen
                </Link>
              )}
            </ModalContext.Consumer>
            {this.state.toSendAnother ? (
              <div>
                <div>Enter Your email address</div>
                <input
                  id="email"
                  onChange={this.handleEmailChange}
                  value={this.state.email}
                />
                <button onClick={this.handleResend}>resend</button>
              </div>
            ) : null}
            {this.state.resendSuccess ? (
              <div>Successfully sent to {this.state.email}</div>
            ) : null}
            {this.state.resendError}
          </React.Fragment>
        )}
      </div>
    );
  }
}
